import React, { useCallback } from "react";
import { FinancialDocument } from "@common/types/financialDocument";
import { DocumentStatusIcons } from "@components/documents/DocumentStatusIcons";
import { Loader } from "@design-system/Loader/Loader";
import { Button } from "@design-system/Button/Button";
import { Link } from "@design-system/Link/Link";
import { TrashIcon } from "@icons";
import { useOverlays } from "contexts/OverlayContext";
import { DocumentName } from "../../../../documents/DocumentName";
import styles from "./ImportedDocuments.module.scss";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface Props {
    onRemove(): void;
    financialDocument: FinancialDocument;
}

export const ImportedDocumentsRow: React.FC<Props> = ({
    financialDocument,
    onRemove,
}) => {
    const { openOverlay } = useOverlays();
    const handleView = useCallback(() => {
        openOverlay("financialDocumentDetailsModal", financialDocument.id);
    }, [financialDocument.id, openOverlay]);

    return (
        <div className={styles.row}>
            <span>
                <Link className={styles.documentName} onClick={handleView}>
                    <DocumentName
                        fileName={financialDocument.fileName}
                        documentId={financialDocument?.id}
                    />
                </Link>
            </span>
            <span>
                <DocumentStatusIcons document={financialDocument} />
            </span>
            <span>
                {financialDocument ? (
                    <Tooltip content="Delete document">
                        <Button
                            variant="destructive"
                            size="md"
                            iconOnly
                            onClick={onRemove}
                            aria-label="Delete document"
                        >
                            <TrashIcon />
                        </Button>
                    </Tooltip>
                ) : (
                    <Loader inline />
                )}
            </span>
        </div>
    );
};
